import { useCallback, useEffect, useState } from 'react';
import { api } from '../../lib/api';

const siguienteOrden = (lista) =>
  (lista || []).reduce(
    (maximo, item) => Math.max(maximo, Number(item.orden) || 0),
    0
  ) + 1;

export default function useRestauranteConfiguracion() {
  const [salones, setSalones] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState('');

  const cargar = useCallback(async () => {
    try {
      // todos=1 trae también los salones y mesas desactivados.
      const response = await api.get('/restaurante/salones', {
        params: { todos: 1 },
      });

      setSalones(
        Array.isArray(response.data) ? response.data : []
      );

      return true;
    } catch (err) {
      console.error(
        'Error cargando configuración de Restaurante:',
        err
      );

      setError(
        err?.response?.data?.error ||
          'No se pudieron cargar los salones.'
      );

      return false;
    } finally {
      setCargando(false);
    }
  }, []);

  useEffect(() => {
    cargar();
  }, [cargar]);

  const ejecutar = async (operacion) => {
    try {
      setGuardando(true);
      setError('');

      await operacion();
      await cargar();

      return { ok: true };
    } catch (err) {
      console.error(
        'Error guardando configuración de Restaurante:',
        err
      );

      const mensaje =
        err?.response?.data?.error ||
        'No se pudo guardar el cambio.';

      setError(mensaje);

      return { ok: false, error: mensaje };
    } finally {
      setGuardando(false);
    }
  };

  const crearSalon = (nombre) =>
    ejecutar(() =>
      api.post('/restaurante/salones', {
        nombre,
        orden: siguienteOrden(salones),
      })
    );

  const actualizarSalon = (id, datos) =>
    ejecutar(() =>
      api.patch(`/restaurante/salones/${id}`, datos)
    );

  const crearMesa = (salon, datos) =>
    ejecutar(() =>
      api.post('/restaurante/mesas', {
        ...datos,
        salon_id: salon.id,
        orden: siguienteOrden(salon.mesas),
      })
    );

  const actualizarMesa = (id, datos) =>
    ejecutar(() =>
      api.patch(`/restaurante/mesas/${id}`, datos)
    );

  return {
    salones,
    cargando,
    guardando,
    error,
    limpiarError: () => setError(''),
    crearSalon,
    actualizarSalon,
    crearMesa,
    actualizarMesa,
  };
}
